import Button from "@material-ui/core/Button";
import styled from "styled-components";

const avatarSize = "70px";

export const SubmitButton = styled(Button)`
  margin-top: 10px !important;
  width: 205px !important;
  height: 20px !important;
  font-size: 10px !important;
  border-radius: 25px !important;
`;

export default theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing()
  },
  logoWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "63px",
    flexShrink: 0
  },
  logoLink: {
    fontSize: 0
  },
  logoImage: {
    cursor: "pointer",
    maxWidth: "85%",
    margin: "auto"
  },
  logoDivider: {
    marginBottom: theme.spacing(2)
  },
  profile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "fit-content",
    marginTop: 20
  },
  avatar: {
    width: avatarSize,
    height: avatarSize
  },
  nameText: {
    marginTop: theme.spacing(2)
  },
  bioText: {},
  profileDivider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  listSubheader: {
    color: theme.palette.text.secondary
  },
  listItem: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      borderRadius: "4px",
      "& $listItemIcon": {
        color: theme.palette.primary.main,
        marginLeft: "-4px"
      }
    },
    "& + &": {
      marginTop: theme.spacing()
    }
  },
  planItem: {
    marginLeft: "10px",
    marginRight: "10px"
  },
  linearBar: {
    width: "205px"
  },
  textLeft: {
    display: "inline",
    float: "left",
  },
  textLeftHistory: {
    display: "inline",
    float: "left",
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer'
    }   
  },
  textRight: {
    display: "inline",
    float: "right"
  },
  textRightHistory: {
    display: "inline",
    float: "right",
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer'
    }   
  },
  activeListItem: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: "4px",
    backgroundColor: theme.palette.primary.light,
    "& $listItemText": {
      color: theme.palette.text.primary
    },
    "& $listItemIcon": {
      color: theme.palette.primary.main,
      marginLeft: "-4px"
    }
  },
  listItemIcon: {
    marginRight: 0
  },
  listItemText: {
    fontWeight: 500,
    color: theme.palette.text.secondary
  },
  listDivider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  }
});
